/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';
import type { NullableMoneyOutput } from './NullableMoneyOutput';
import {
    NullableMoneyOutputFromJSON,
    NullableMoneyOutputFromJSONTyped,
    NullableMoneyOutputToJSON,
    NullableMoneyOutputToJSONTyped,
} from './NullableMoneyOutput';
import type { AssignedMarketingResultData } from './AssignedMarketingResultData';
import {
    AssignedMarketingResultDataFromJSON,
    AssignedMarketingResultDataFromJSONTyped,
    AssignedMarketingResultDataToJSON,
    AssignedMarketingResultDataToJSONTyped,
} from './AssignedMarketingResultData';

/**
 * 
 * @export
 * @interface PartialProfitabilityData
 */
export interface PartialProfitabilityData {
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof PartialProfitabilityData
     */
    knownRevenue?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof PartialProfitabilityData
     */
    knownPurchaseCost?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof PartialProfitabilityData
     */
    knownGrossProfit?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof PartialProfitabilityData
     */
    knownProfitAfterAllMarketing?: NullableMoneyOutput | null;
    /**
     * 
     * @type {number}
     * @memberof PartialProfitabilityData
     */
    knownPoas?: number | null;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof PartialProfitabilityData
     */
    lineRevenue?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof PartialProfitabilityData
     */
    unknownRevenue?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof PartialProfitabilityData
     */
    headerRevenueGap?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof PartialProfitabilityData
     */
    knownLineCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialProfitabilityData
     */
    unknownLineCount?: number;
    /**
     * Product lines without a present purchase price and with a non-zero or unavailable exact net sales value. Zero-value sales lines are excluded from this action count.
     * @type {number}
     * @memberof PartialProfitabilityData
     */
    actionableUnknownLineCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialProfitabilityData
     */
    estimatedLineCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialProfitabilityData
     */
    knownOrderCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialProfitabilityData
     */
    unknownOrderCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PartialProfitabilityData
     */
    available?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartialProfitabilityData
     */
    complete?: boolean;
    /**
     * 
     * @type {PartialProfitabilityDataQualityEnum}
     * @memberof PartialProfitabilityData
     */
    quality?: PartialProfitabilityDataQualityEnum;
    /**
     * 
     * @type {number}
     * @memberof PartialProfitabilityData
     */
    revenueCoveragePercent?: number | null;
    /**
     * 
     * @type {AssignedMarketingResultData}
     * @memberof PartialProfitabilityData
     */
    assignedMarketingResult?: AssignedMarketingResultData | null;
}


/**
 * @export
 */
export const PartialProfitabilityDataQualityEnum = {
    Observed: 'observed',
    Estimated: 'estimated',
    Unavailable: 'unavailable'
} as const;
export type PartialProfitabilityDataQualityEnum = typeof PartialProfitabilityDataQualityEnum[keyof typeof PartialProfitabilityDataQualityEnum];


/**
 * Check if a given object implements the PartialProfitabilityData interface.
 */
export function instanceOfPartialProfitabilityData(value: object): value is PartialProfitabilityData {
    return true;
}

export function PartialProfitabilityDataFromJSON(json: any): PartialProfitabilityData {
    return PartialProfitabilityDataFromJSONTyped(json, false);
}

export function PartialProfitabilityDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartialProfitabilityData {
    if (json == null) {
        return json;
    }
    return {
        
        'knownRevenue': json['knownRevenue'] === undefined ? undefined : json['knownRevenue'] === null ? null : NullableMoneyOutputFromJSON(json['knownRevenue']),
        'knownPurchaseCost': json['knownPurchaseCost'] === undefined ? undefined : json['knownPurchaseCost'] === null ? null : NullableMoneyOutputFromJSON(json['knownPurchaseCost']),
        'knownGrossProfit': json['knownGrossProfit'] === undefined ? undefined : json['knownGrossProfit'] === null ? null : NullableMoneyOutputFromJSON(json['knownGrossProfit']),
        'knownProfitAfterAllMarketing': json['knownProfitAfterAllMarketing'] === undefined ? undefined : json['knownProfitAfterAllMarketing'] === null ? null : NullableMoneyOutputFromJSON(json['knownProfitAfterAllMarketing']),
        'knownPoas': json['knownPoas'] === undefined ? undefined : json['knownPoas'] === null ? null : json['knownPoas'],
        'lineRevenue': json['lineRevenue'] == null ? undefined : MoneyOutputFromJSON(json['lineRevenue']),
        'unknownRevenue': json['unknownRevenue'] == null ? undefined : MoneyOutputFromJSON(json['unknownRevenue']),
        'headerRevenueGap': json['headerRevenueGap'] == null ? undefined : MoneyOutputFromJSON(json['headerRevenueGap']),
        'knownLineCount': json['knownLineCount'] == null ? undefined : json['knownLineCount'],
        'unknownLineCount': json['unknownLineCount'] == null ? undefined : json['unknownLineCount'],
        'actionableUnknownLineCount': json['actionableUnknownLineCount'] == null ? undefined : json['actionableUnknownLineCount'],
        'estimatedLineCount': json['estimatedLineCount'] == null ? undefined : json['estimatedLineCount'],
        'knownOrderCount': json['knownOrderCount'] == null ? undefined : json['knownOrderCount'],
        'unknownOrderCount': json['unknownOrderCount'] == null ? undefined : json['unknownOrderCount'],
        'available': json['available'] == null ? undefined : json['available'],
        'complete': json['complete'] == null ? undefined : json['complete'],
        'quality': json['quality'] == null ? undefined : json['quality'],
        'revenueCoveragePercent': json['revenueCoveragePercent'] === undefined ? undefined : json['revenueCoveragePercent'] === null ? null : json['revenueCoveragePercent'],
        'assignedMarketingResult': json['assignedMarketingResult'] === undefined ? undefined : json['assignedMarketingResult'] === null ? null : AssignedMarketingResultDataFromJSON(json['assignedMarketingResult']),
    };
}

export function PartialProfitabilityDataToJSON(json: any): PartialProfitabilityData {
    return PartialProfitabilityDataToJSONTyped(json, false);
}

export function PartialProfitabilityDataToJSONTyped(value?: PartialProfitabilityData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'knownRevenue': NullableMoneyOutputToJSON(value['knownRevenue']),
        'knownPurchaseCost': NullableMoneyOutputToJSON(value['knownPurchaseCost']),
        'knownGrossProfit': NullableMoneyOutputToJSON(value['knownGrossProfit']),
        'knownProfitAfterAllMarketing': NullableMoneyOutputToJSON(value['knownProfitAfterAllMarketing']),
        'knownPoas': value['knownPoas'],
        'lineRevenue': MoneyOutputToJSON(value['lineRevenue']),
        'unknownRevenue': MoneyOutputToJSON(value['unknownRevenue']),
        'headerRevenueGap': MoneyOutputToJSON(value['headerRevenueGap']),
        'knownLineCount': value['knownLineCount'],
        'unknownLineCount': value['unknownLineCount'],
        'actionableUnknownLineCount': value['actionableUnknownLineCount'],
        'estimatedLineCount': value['estimatedLineCount'],
        'knownOrderCount': value['knownOrderCount'],
        'unknownOrderCount': value['unknownOrderCount'],
        'available': value['available'],
        'complete': value['complete'],
        'quality': value['quality'],
        'revenueCoveragePercent': value['revenueCoveragePercent'],
        'assignedMarketingResult': AssignedMarketingResultDataToJSON(value['assignedMarketingResult']),
    };
}

